import { LogoutOptions, useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'
import { ClearLoginTries } from './useAppLogin'

export const useAppLogout = () => {
  const { logout } = useAuth0()

  const appLogout = useCallback(
    async (options?: LogoutOptions) => {
      ClearLoginTries()
      window['Intercom']?.('shutdown')
      await window.QFMessenger?.('shutdown')
      window.localStorage.removeItem('rh24_lastVisitedWorkspaceId')

      const logoutOptions = {
        logoutParams: {
          returnTo: `${window.location.origin}/logout`,
        },
        ...(options || {}),
      }

      logoutOptions.clientId = import.meta.env.VITE_AUTH0_CLIENT_ID

      try {
        await logout(logoutOptions)
      } catch (err) {
        console.error('appLogoutErr', err)
      }
    },
    [logout]
  )

  return {
    appLogout,
  }
}
